import { useMutation } from 'react-query'
import { showConfirmAlert, showError } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteSelectedPaciente } from '../../core/_requests'
import { TableBulkDangerButton, TableSelectionBar, useToast } from '../../../../../../components'

const UsersListGrouping = () => {
  const { selected, clearSelected } = useListView()
  const { refetch } = useQueryResponse()
  const { showToast } = useToast()
  const count = selected.length

  // `refetch` da própria listagem (antes invalidava `USERS_LIST`, chave que esta tela não usa, e
  // a lista não atualizava depois de excluir).
  const deleteSelectedItems = useMutation(() => deleteSelectedPaciente(selected), {
    onSuccess: () => {
      showToast({
        variant: 'success',
        title: count === 1 ? '1 paciente excluído.' : `${count} pacientes excluídos.`,
      })
      clearSelected()
      refetch()
    },
    onError: showError,
  })

  const askRemove = async () => {
    const confirmed = await showConfirmAlert({
      title: count === 1 ? 'Excluir 1 paciente?' : `Excluir ${count} pacientes?`,
      text: 'Os pacientes selecionados serão excluídos. Para só tirá-los de uso, prefira inativar.',
      confirmButtonText: count === 1 ? 'Excluir paciente' : `Excluir ${count} pacientes`,
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await deleteSelectedItems.mutateAsync()
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <TableBulkDangerButton onClick={askRemove} disabled={deleteSelectedItems.isLoading}>
        {count === 1 ? 'Excluir selecionado' : 'Excluir selecionados'}
      </TableBulkDangerButton>
    </TableSelectionBar>
  )
}

export { UsersListGrouping }
